export class FetchContainerAction {
  static readonly type = '[Container] Fetch Containers';
}
